<template>
    <div id="GeERI">
        <h1>ERI-Cards</h1>
    </div>
</template>